export function getBuyTokenAmountFontSize(value) {
    return value.length > 10 ? "26px" : value.length > 6 ? "34px" : "50px";
}
//# sourceMappingURL=utils.js.map